import {ParamsModel} from 'src/app/modules/common/Model'
import {DeleteSubsidiaryPageModel, SortSubsidiaryPageModel} from '../Model'
import {SubsidiaryPageModel} from '../Model/SubsidiaryPageModel'
import {actionTypes} from './constants'
export const actions = {
  // get SubsidiaryPage
  getAllSubsidiaryPage: () => ({
    type: actionTypes.GET_ALL_SUBSIDIARY_PAGE_START,
  }),
  getAllSubsidiaryPageSuccess: (data: SubsidiaryPageModel) => ({
    type: actionTypes.GET_ALL_SUBSIDIARY_PAGE_SUCCESS,
    payload: data,
  }),
  getAllSubsidiaryPageFinish: () => ({
    type: actionTypes.GET_ALL_SUBSIDIARY_PAGE_FINISH,
  }),

  // get SubsidiaryPage DATA
  getSubsidiaryPage: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_SUBSIDIARY_PAGE_START,
    payload: params,
  }),
  getSubsidiaryPageSuccess: (data: SubsidiaryPageModel) => ({
    type: actionTypes.GET_SUBSIDIARY_PAGE_SUCCESS,
    payload: data,
  }),
  getSubsidiaryPageFinish: () => ({
    type: actionTypes.GET_SUBSIDIARY_PAGE_FINISH,
  }),

  // create key
  addSubsidiaryPage: (data: SubsidiaryPageModel) => ({
    type: actionTypes.ADD_SUBSIDIARY_PAGE_START,
    payload: data,
  }),
  addSubsidiaryPageSuccess: (task: any) => ({
    type: actionTypes.ADD_SUBSIDIARY_PAGE_SUCCESS,
    payload: task,
  }),
  addSubsidiaryPageFinish: () => ({
    type: actionTypes.ADD_SUBSIDIARY_PAGE_FINISH,
  }),
  resetSubsidiaryPage: () => ({
    type: actionTypes.RESET_SUBSIDIARY_PAGE,
  }),

  //Update SubsidiaryPage
  updateSubsidiaryPage: (data: SubsidiaryPageModel, id: string) => ({
    type: actionTypes.UPDATE_SUBSIDIARY_PAGE_START,
    payload: data,
    id,
  }),

  updateSubsidiaryPageSuccess: (data: SubsidiaryPageModel) => ({
    type: actionTypes.UPDATE_SUBSIDIARY_PAGE_SUCCESS,
    payload: data,
  }),

  updateSubsidiaryPageFinish: () => ({
    type: actionTypes.UPDATE_SUBSIDIARY_PAGE_FINISH,
  }),

  // delete key
  deleteSubsidiaryPage: (data: DeleteSubsidiaryPageModel[]) => ({
    type: actionTypes.DELETE_SUBSIDIARY_PAGE_START,
    payload: {subsidiaryPageId: data},
  }),
  deleteSubsidiaryPageSuccess: (data: any) => ({
    type: actionTypes.DELETE_SUBSIDIARY_PAGE_SUCCESS,
    payload: data,
  }),
  deleteSubsidiaryPageFinish: () => ({
    type: actionTypes.DELETE_SUBSIDIARY_PAGE_FINISH,
  }),

  //Enable SubsidiaryPage
  enableSubsidiaryPage: (data: any) => ({
    type: actionTypes.ENABLE_SUBSIDIARY_PAGE_REQUEST,
    payload: {data},
  }),

  enableSubsidiaryPageSuccess: (task: any) => ({
    type: actionTypes.ENABLE_SUBSIDIARY_PAGE_SUCCESS,
    payload: task,
  }),
  enableSubsidiaryPageFinish: () => ({
    type: actionTypes.ENABLE_SUBSIDIARY_PAGE_FINISH,
  }),

  //Disable SubsidiaryPage
  disableSubsidiaryPage: (data: any) => ({
    type: actionTypes.DISABLE_SUBSIDIARY_PAGE_REQUEST,
    payload: {data},
  }),

  disableSubsidiaryPageSuccess: (task: any) => ({
    type: actionTypes.DISABLE_SUBSIDIARY_PAGE_SUCCESS,
    payload: task,
  }),
  disableSubsidiaryPageFinish: () => ({
    type: actionTypes.DISABLE_SUBSIDIARY_PAGE_FINISH,
  }),

  //Enable SubsidiaryPage
  singleEnableSubsidiaryPage: (data: any) => ({
    type: actionTypes.SINGLE_ENABLE_SUBSIDIARY_PAGE_REQUEST,
    payload: {data},
  }),

  singleEnableSubsidiaryPageSuccess: (task: any) => ({
    type: actionTypes.SINGLE_ENABLE_SUBSIDIARY_PAGE_SUCCESS,
    payload: task,
  }),
  singleEnableSubsidiaryPageFinish: () => ({
    type: actionTypes.SINGLE_ENABLE_SUBSIDIARY_PAGE_FINISH,
  }),

  //Disable SubsidiaryPage
  singleDisableSubsidiaryPage: (data: any) => ({
    type: actionTypes.SINGLE_DISABLE_SUBSIDIARY_PAGE_REQUEST,
    payload: {data},
  }),

  singleDisableSubsidiaryPageSuccess: (task: any) => ({
    type: actionTypes.SINGLE_DISABLE_SUBSIDIARY_PAGE_SUCCESS,
    payload: task,
  }),
  singleDisableSubsidiaryPageFinish: () => ({
    type: actionTypes.SINGLE_DISABLE_SUBSIDIARY_PAGE_FINISH,
  }),

  
  // sort
  sortSubsidiaryPage: (data: SortSubsidiaryPageModel) => ({
    type: actionTypes.SORT_SUBSIDIARY_PAGE_START,
    payload: data,
  }),
  sortSubsidiaryPageSuccess: (data: Array<SubsidiaryPageModel>) => ({
    type: actionTypes.SORT_SUBSIDIARY_PAGE_SUCCESS,
    payload: data,
  }),
  sortSubsidiaryPageFinish: () => ({
    type: actionTypes.SORT_SUBSIDIARY_PAGE_FINISH,
  }),
  sortSubsidiaryPageReset: () => ({
    type: actionTypes.SORT_SUBSIDIARY_PAGE_RESET,
  }),
}
